import React, { Dispatch, SetStateAction } from 'react';
import {
  Platform, StyleSheet, Text, TextInput, TouchableOpacity, View,
} from 'react-native';
import Colors from '../constants/Colors';
import SearchIcon from './SearchIcon';
import { logEvent } from './LogEvent';

interface FilterSearchBoxProps {
  title: string,
  onChangeText: Dispatch<SetStateAction<string>>,
  value: string,
}

const FilterSearchBox = ({ title, onChangeText, value }: FilterSearchBoxProps) => <>
  <View style={styles.header}>
    <Text style={styles.filterHeading}>{title}</Text>
    {value?.length > 0 && <TouchableOpacity
      style={styles.resetButton}
      onPress={() => {
        logEvent('FilterSearchBox', 'Reset_filter_Pressed');
        onChangeText('');
      }}
    >
      <Text style={styles.resetButtonText}>
        {'RESET'}
      </Text>
    </TouchableOpacity>}
  </View>
  <View style={styles.filterSearchBox}>
    <TextInput
      style={styles.inputText}
      {...{ value, onChangeText }}
      placeholder={`Enter ${title.toLowerCase()}`}
      placeholderTextColor={Colors.light.hereworksBlack400}
    />
    <SearchIcon />
  </View>
</>;

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignSelf: 'stretch',
    marginTop: 12,
  },
  filterSearchBox: {
    paddingVertical: Platform.OS === 'ios' ? 6 : 3,
    borderRadius: 10,
    backgroundColor: '#fff',
    borderColor: Colors.light.hereworksBlue100,
    borderWidth: 1.5,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
    marginTop: 4,
    paddingHorizontal: 8,
  },
  filterHeading: {
    fontSize: 14,
    lineHeight: 18,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack600,
  },
  inputText: {
    color: Colors.light.hereworksBlack600,
    alignSelf: 'stretch',
    fontFamily: 'Poppins_400Regular',
    alignItems: 'center',
    flex: 1,
    fontSize: 14,
    lineHeight: Platform.OS === 'ios' ? undefined : 21,
    alignContent: 'center',
    outlineWidth: 0,
  },
  resetButton: {
    justifyContent: 'center',
    zIndex: -1,
    flex: 1,
    alignItems: 'flex-end',
  },
  resetButtonText: {
    color: Colors.light.hereworksPrimaryGrey,
    fontSize: 11,
    fontFamily: 'Roboto_500Medium',
    borderBottomWidth: 1,
    borderColor: Colors.light.hereworksPrimaryGrey,
  },
});

export default FilterSearchBox;
